/*
Theme Name: HUGE
Description: Creative Coming Soon Template
Author: SquirrelLabs
Author URI: https://themeforest.net/user/squirrellabs/portfolio?ref=SquirrelLab
Version: 1.0
License: https://themeforest.net/licenses/standard
*/ (function(window1) {
    'use strict';
    // Helper vars and functions.
    function extend(a, b) {
        for(var key in b)if (b.hasOwnProperty(key)) a[key] = b[key];
        return a;
    }
    /**
	 * RevealFx obj.
	 */ function RevealFx1(el, options) {
        this.el = el;
        this.options = extend({}, this.options);
        extend(this.options, options);
    }
    /**
	 * RevealFx options.
	 */ RevealFx1.prototype.options = {
        // If true, then the content will be hidden until it´s "revealed".
        isContentHidden: true,
        // The animation/reveal settings. This can be set initially or passed when calling the reveal method.
        revealSettings: {
            // Animation direction: left right (lr) || right left (rl) || top bottom (tb) || bottom top (bt).
            direction: 'lr',
            // Revealer´s background color.
            bgcolor: '#f0f0f0',
            // Animation speed. This is the speed to "cover" and also "uncover" the element (seperately, not the total time).
            duration: 500,
            // Animation easing. This is the easing to "cover" and also "uncover" the element.
            easing: 'easeInOutQuint',
            // percentage-based value representing how much of the area should be left covered.
            coverArea: 0,
            // Callback for when the revealer is covering the element (halfway through of the whole animation).
            onCover: function(contentEl, revealerEl) {
                return false;
            },
            // Callback for when the animation starts (animation start).
            onStart: function(contentEl, revealerEl) {
                return false;
            },
            // Callback for when the revealer has completed uncovering (animation end).
            onComplete: function(contentEl, revealerEl) {
                return false;
            }
        }
    };
    /**
	 * Gets the revealer element´s transform and transform origin.
	 */ RevealFx1.prototype._getTransformSettings = function(direction) {
        var val, origin, origin_2;
        switch(direction){
            case 'lr':
                val = 'scale3d(0,1,1)';
                origin = '0 50%';
                origin_2 = '100% 50%';
                break;
            case 'rl':
                val = 'scale3d(0,1,1)';
                origin = '100% 50%';
                origin_2 = '0 50%';
                break;
            case 'tb':
                val = 'scale3d(1,0,1)';
                origin = '50% 0';
                origin_2 = '50% 100%';
                break;
            case 'bt':
                val = 'scale3d(1,0,1)';
                origin = '50% 100%';
                origin_2 = '50% 0';
                break;
            default:
                val = 'scale3d(0,1,1)';
                origin = '0 50%';
                origin_2 = '100% 50%';
                break;
        }
        return {
            // transform value.
            val: val,
            // initial and halfway/final transform origin.
            origin: {
                initial: origin,
                halfway: origin_2
            }
        };
    };
    /**
	 * Reveal animation. If revealSettings is passed, then it will overwrite the options.revealSettings.
	 */ RevealFx1.prototype.reveal = function(revealSettings) {
        // Do nothing if currently animating.
        if (this.isAnimating) return false;
        this.isAnimating = true;
        this.content = jQuery('.revealer-content')[0];
        this.revealer = jQuery('.revealer-animation')[0];
        // Set the revealer element´s transform and transform origin.
        var defaults = {
            duration: 500,
            easing: 'easeInOutQuint',
            delay: 0,
            bgcolor: '#f0f0f0',
            direction: 'lr',
            coverArea: 0
        }, revealSettings = revealSettings || this.options.revealSettings, direction = revealSettings.direction || defaults.direction, transformSettings = this._getTransformSettings(direction);
        this.revealer.style.WebkitTransform = this.revealer.style.transform = transformSettings.val;
        this.revealer.style.WebkitTransformOrigin = this.revealer.style.transformOrigin = transformSettings.origin.initial;
        // Set the Revealer´s background color.
        this.revealer.style.backgroundColor = revealSettings.bgcolor || defaults.bgcolor;
        // Show it. By default the revealer element has opacity = 0 (CSS).
        this.revealer.style.opacity = 1;
        // Animate it.
        var self = this, // Second animation step.
        animationSettings_2 = {
            complete: function() {
                self.isAnimating = false;
                if (typeof revealSettings.onComplete === 'function') revealSettings.onComplete(self.content, self.revealer);
            }
        }, // First animation step.
        animationSettings = {
            delay: revealSettings.delay || defaults.delay,
            complete: function() {
                self.revealer.style.WebkitTransformOrigin = self.revealer.style.transformOrigin = transformSettings.origin.halfway;
                if (typeof revealSettings.onCover === 'function') revealSettings.onCover(self.content, self.revealer);
                anime(animationSettings_2);
            }
        };
        animationSettings.targets = animationSettings_2.targets = this.revealer;
        animationSettings.duration = animationSettings_2.duration = revealSettings.duration || defaults.duration;
        animationSettings.easing = animationSettings_2.easing = revealSettings.easing || defaults.easing;
        var coverArea = revealSettings.coverArea || defaults.coverArea;
        if (direction === 'lr' || direction === 'rl') {
            animationSettings.scaleX = [
                0,
                1
            ];
            animationSettings_2.scaleX = [
                1,
                coverArea / 100
            ];
        } else {
            animationSettings.scaleY = [
                0,
                1
            ];
            animationSettings_2.scaleY = [
                1,
                coverArea / 100
            ];
        }
        if (typeof revealSettings.onStart === 'function') revealSettings.onStart(self.content, self.revealer);
        anime(animationSettings);
    };
    window1.RevealFx = RevealFx1;
})(window);
(function() {
    var navEl = jQuery('nav.menu'), revealer = new RevealFx(navEl[0]), closeCtrl = navEl.find('.btn-close')[0];
    document.querySelector('.btn-menu').addEventListener('click', function() {
        jQuery('.menu').addClass('menu-open');
        revealer.reveal({
            bgcolor: '#ff524e',
            duration: 400,
            easing: 'easeInOutCubic',
            onCover: function(contentEl, revealerEl) {
                contentEl.style.opacity = 1;
            },
            onComplete: function() {
                closeCtrl.addEventListener('click', closeMenu);
                jQuery('.revealer-content').addClass('active');
            }
        });
    });
    function closeMenu() {
        closeCtrl.removeEventListener('click', closeMenu);
        revealer.reveal({
            bgcolor: '#ff524e',
            duration: 400,
            easing: 'easeInOutCubic',
            onCover: function(contentEl, revealerEl) {
                contentEl.style.opacity = 0;
                jQuery('.revealer-content').removeClass('active');
            },
            onComplete: function() {
                navEl.removeClass('menu-open');
            }
        });
    }
})();

//# sourceMappingURL=404.19781c9d.js.map
